import { Surface } from '@heroui/react'
import { useTranslations } from 'use-intl'
import { LocaleSwitcher } from '~/components/common/locale-switcher'
import { LocalizedLink } from '~/components/common/localized-link'
import { ModeToggle } from '~/components/common/mode-toggle'
import { MobilePublicNavMenu, PublicHeaderActions, PublicNavLinks } from './public-header-nav'

export function Header() {
  const t = useTranslations('components.layout.header')

  return (
    <Surface variant="default" className="sticky top-0 z-50 w-full border-b border-divider/50 backdrop-blur-md bg-background/80">
      <div className="container mx-auto flex h-16 items-center justify-between px-4 lg:px-6">
        <div className="flex items-center gap-6">
          <LocalizedLink to="/" className="flex items-center gap-2 font-bold text-xl tracking-tight">
            <img src="/logo.png" alt="Logo" className="w-10 h-10 object-contain" />
            <span className="hidden md:block">{t('brandName')}</span>
          </LocalizedLink>
          <PublicNavLinks />
        </div>
        <div className="flex items-center gap-3">
          <ModeToggle />
          <LocaleSwitcher />
          <PublicHeaderActions className="hidden md:flex items-center gap-3" />
          <MobilePublicNavMenu />
        </div>
      </div>
    </Surface>
  )
}
